export default "__VITE_ASSET__D7V45bYG__"